import { passwordStrength } from '@/lib/validators';

/** Real-time password strength bar + label. */
export default function PasswordStrength({ value, testId }) {
  const s = passwordStrength(value || '');
  const pct = Math.min(100, (s.score / 6) * 100);
  if (!value) return null;
  return (
    <div className="mt-1 space-y-0.5" data-testid={testId || 'password-strength'}>
      <div className="h-1.5 w-full bg-[#E5F2F1] rounded-full overflow-hidden">
        <div
          className="h-full transition-all duration-200"
          style={{ width: `${pct}%`, backgroundColor: s.color || '#E5F2F1' }}
        />
      </div>
      <p className="text-[10px] font-medium" style={{ color: s.color || '#4A6B68' }}>
        {s.label}
      </p>
    </div>
  );
}
